// This is a polyfill for the process module used by Axios
window.process = {
  env: {
    NODE_ENV: process.env.NODE_ENV || 'development',
  },
  browser: true,
  version: '',
  nextTick: function(fn) {
    setTimeout(fn, 0);
  }
};
